"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateZipCode = exports.FormatZipCode = void 0;
function FormatZipCode(zipCode) {
    return zipCode.trim().replace(" ", "").replace("-", "").replace("(", "").replace(")", "");
}
exports.FormatZipCode = FormatZipCode;
function ValidateZipCode(zipCode) {
    if (typeof zipCode !== "string")
        return false;
    zipCode = zipCode.trim();
    return new RegExp(/^[0-9]{5}$/).test(FormatZipCode(zipCode));
}
exports.ValidateZipCode = ValidateZipCode;
//# sourceMappingURL=ValidationZipCode.js.map